import {
   ChangeDetectionStrategy,
   Component,
   ElementRef,
   EventEmitter,
   Input,
   OnInit,
   Output,
   ViewChild,
} from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { Actions, ofType } from '@ngrx/effects';
import { Countries } from 'src/app/common-components/confirmation-dialog/enumerations/countries';
import { UsStates } from 'src/app/common-components/confirmation-dialog/enumerations/states';
import { countryDisplayWith, countrySearch, getCountries } from 'src/app/common-components/helpers/country-helper';
import { AddLocationData } from '../models/add-location-data';
import { createLocationAndAddAnotherSuccess } from '../state/add-location.actions';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-add-location-view',
    styleUrls: ['./add-location-view.component.scss'],
    templateUrl: './add-location-view.component.html',
    standalone: false
})
export class AddLocationViewComponent implements OnInit {
   @ViewChild('name') name: ElementRef;

   @Input() callState: CallState;

   @Output() formSubmitted = new EventEmitter<AddLocationData>();

   @Output() formCanceled = new EventEmitter<void>();

   @Output() saveAndAddAnother = new EventEmitter<AddLocationData>();

   @Input() form: UntypedFormGroup;

   countries = getCountries();

   states = UsStates.states;

   constructor(private actions$: Actions) {}

   ngOnInit(): void {
      this.actions$.pipe(ofType(createLocationAndAddAnotherSuccess)).subscribe(() => {
         this.clearAddLocationFields();
         this.form.markAsPristine();
         this.form.markAsUntouched();
         this.name.nativeElement.focus();
      });
   }

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.formSubmitted.emit();
      }
   }

   onCreateAndAddAnother() {
      if (this.form.valid) {
         this.saveAndAddAnother.emit();
         this.form.markAsPristine();
         this.form.markAsUntouched();
      } else {
         this.form.markAllAsTouched();
      }
   }

   clearAddLocationFields() {
      this.form.reset();
   }

   handleStateChange(isDirty: boolean): void {
      if (isDirty) {
         this.form.controls['state'].markAsDirty();
         this.form.controls['state'].updateValueAndValidity();
      }
   }

   countryDisplayWith(option: Countries): string {
      return countryDisplayWith(option);
   }

   countrySearch(searchText: string) {
      this.countries = countrySearch(searchText);
   }

   countrySearchReset() {
      this.countries = getCountries();
   }

   stateDisplayWith(option: { abbreviation: string; name: string }): string {
      return `${option ?? ''}`;
   }

   stateSearch(searchText: string) {
      this.states = UsStates.states.filter(
         (state) =>
            state.name.toUpperCase().includes(searchText.toUpperCase()) ||
            state.abbreviation.toUpperCase().includes(searchText.toUpperCase())
      );
   }

   stateSearchReset() {
      this.states = UsStates.states;
   }
}
